// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"formik-select-styles_selectWrapper__GyTBg"};